import { debounceTime } from "rxjs/operators";
import { subsequent } from "./subsequent";
export function debounceTimeSubsequent(duration, countOrScheduler, scheduler) {
    let count;
    if (typeof countOrScheduler === "number") {
        count = countOrScheduler;
    }
    else {
        count = 1;
        scheduler = countOrScheduler;
    }
    return subsequent(count, debounceTime(duration, scheduler));
}
//# sourceMappingURL=debounceTimeSubsequent.js.map